import { render, staticRenderFns } from "./ControversyList.vue?vue&type=template&id=2071741e&scoped=true"
import script from "./ControversyList.vue?vue&type=script&lang=js"
export * from "./ControversyList.vue?vue&type=script&lang=js"
import style0 from "./ControversyList.vue?vue&type=style&index=0&id=2071741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071741e",
  null
  
)

export default component.exports